import { createAsyncAction } from "typesafe-actions";
export const listKeys = createAsyncAction("[keys] list request", "[keys] list success", "[keys] list failure", "[keys] list cancel")();
export const createKey = createAsyncAction("[keys] create request", "[keys] create success", "[keys] create failure", "[keys] create cancel")();
export const deleteKey = createAsyncAction("[keys] delete request", "[keys] delete success", "[keys] delete failure", "[keys] delete cancel")();
